import { Theme, useTheme } from '@mui/joy/styles';

import { FormField } from 'core/components';
import { InputType } from 'core/enums';
import { useFormContext } from 'core/states';
import { Size, Variant } from 'theme/enums';

interface IProps {
  name: string;
  label: string;
  disabled?: boolean;
}

export const SwitchField = ({ name, label, disabled }: IProps) => {
  const theme = useTheme();

  const { control, errors, watch } = useFormContext();

  const isChecked = watch(name);

  return (
    <FormField
      name={name}
      type={InputType.SWITCH}
      inputProps={{
        control,
        error: errors?.[name],
        label,
        size: Size.MD,
        variant: isChecked ? Variant.SOFT : Variant.SOLID,
        ...switchSxProps(isChecked, theme),
        disabled,
      }}
    />
  );
};

const switchSxProps = (isChecked: boolean, theme: Theme) => ({
  sx: {
    '--Switch-trackBackground': isChecked
      ? `${theme.palette.primary.softBg} !important`
      : theme.palette.neutral[400],
  },
  labelSx: {
    color: theme.palette.neutral[isChecked ? 800 : 600],
  },
});
